


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const sendQuotationEmailReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.SEND_QUOTATION_CUSTOMER:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.SEND_QUOTATION_CUSTOMER_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.SEND_QUOTATION_CUSTOMER_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
